import React, { Fragment } from "react";

function FullTextFilter({
  filter, onChange,val
}) {
  const {name} = filter;
  return (
      <div className="group" key={name}>
        <label>
          <span className="label">Value</span>
          <input
            type="text"
            placeholder={filter.placeholder}
            value={val.value ? val.value : ""}
            onChange={(event) => {
              onChange(event, filter.value, "value");
            }}
           />
         </label>
      </div>
  );
}

export default FullTextFilter;


